(() => {
  const root = document.querySelector('[data-rtp-refinements]');
  if (!root) return;
  const currentTags = JSON.parse(root.dataset.currentTags || '[]');
  const prefixes = ['rtp-department-', 'rtp-item-', 'rtp-gender-', 'rtp-audience-', 'rtp-devotion-', 'rtp-season-'];
  const destinationFor = (tags) => {
    const destination = new URL(window.location.href);
    const base = new URL(root.dataset.baseUrl, window.location.origin);
    destination.searchParams.delete('page');
    const uniqueTags = [...new Set(tags)];
    if (/\/collections\/(types|vendors)$/.test(base.pathname)) {
      destination.pathname = base.pathname;
      if (uniqueTags.length) destination.searchParams.set('constraint', uniqueTags.join('+'));
      else destination.searchParams.delete('constraint');
    } else {
      destination.pathname = base.pathname.replace(/\/$/, '') + (uniqueTags.length ? '/' + uniqueTags.join('+') : '');
      destination.searchParams.delete('constraint');
    }
    return destination.href;
  };
  root.querySelectorAll('[data-rtp-refinement]').forEach(select => {
    select.addEventListener('change', () => {
      const tags = currentTags.filter(tag => !tag.startsWith(select.dataset.rtpRefinement));
      if (select.value) tags.push(select.value);
      window.location.assign(destinationFor(tags));
    });
  });
  root.querySelector('[data-rtp-clear-refinements]')?.addEventListener('click', () => {
    window.location.assign(destinationFor(currentTags.filter(tag => !prefixes.some(prefix => tag.startsWith(prefix)))));
  });
  document.querySelector('[data-rtp-language]')?.addEventListener('change', event => {
    const tags = currentTags.filter(tag => tag !== 'english' && tag !== 'spanish');
    const selected = new URL(event.target.value, window.location.origin);
    if (selected.pathname.endsWith('/english') || selected.searchParams.get('constraint') === 'English') tags.push('english');
    if (selected.pathname.endsWith('/spanish') || selected.searchParams.get('constraint') === 'Spanish') tags.push('spanish');
    window.location.assign(destinationFor(tags));
  });
})();
